// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";

const getCommonUrl = () => {

  const protocol = window.location.protocol;

  const host = window.location.host;

  return `${protocol}//${host}`;
};

let commonUrl = getCommonUrl();

let baseUrl = {
  commonUrl
}

export default baseUrl;

// let commonUrl = "http://www.gpt4drones.top";//源码分享站-ymfxz.com
 
// let baseUrl = {
//     commonUrl
// }
 
// export default baseUrl